function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.1424 0C16.7479 0 16.4281 0.319796 16.4281 0.714299V3.32356C12.7507 -0.236719 6.88343 -0.141713 3.32315 3.53567C1.64527 5.26875 0.709239 7.58776 0.713884 9.99998C0.713884 10.3945 1.03368 10.7143 1.42818 10.7143C1.82269 10.7143 2.14244 10.3945 2.14244 9.99998C2.14332 5.66061 5.66175 2.14353 10.0012 2.1444C12.205 2.14482 14.3073 3.07081 15.7953 4.69641L12.6311 5.75139C12.2563 5.87607 12.0535 6.28091 12.1782 6.65566C12.3029 7.03041 12.7077 7.23318 13.0825 7.1085L17.3682 5.67995C17.6607 5.58252 17.8577 5.3083 17.8568 4.99997V0.714257C17.8567 0.319796 17.5369 0 17.1424 0Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5712 9.28564C18.1767 9.28564 17.8569 9.60544 17.8569 9.99994C17.856 14.3393 14.3376 17.8564 9.9982 17.8555C7.79436 17.8551 5.69206 16.9291 4.20403 15.3035L7.3683 14.2485C7.74305 14.1239 7.94583 13.719 7.82115 13.3443C7.69647 12.9695 7.29163 12.7667 6.91688 12.8914L2.63117 14.32C2.33862 14.4174 2.14162 14.6916 2.14258 15V19.2857C2.14258 19.6802 2.46238 20 2.85688 20C3.25138 20 3.57118 19.6802 3.57118 19.2857V16.6764C7.2486 20.2366 13.1159 20.1417 16.6762 16.4643C18.354 14.7312 19.2901 12.4122 19.2854 9.99994C19.2855 9.60544 18.9657 9.28564 18.5712 9.28564Z",
  fill: "white"
});

var SvgRefresh = function SvgRefresh(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRefresh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/refresh.6610f46b.svg";
export { ForwardRef as ReactComponent };